module.exports = __webpack_public_path__ + "static/media/AdobeStock_576823402.82d0d5d7.webp";